angular.module('main').directive('tdPaid', [
	function() {
		return {
			restrict: 'AE',
			template:
				'<td>' +
				'<p class="invoice-blocks web mb-0 {{paymentStatus | lowercase}}">{{paymentStatus | uppercase}}</p>' +
				'</td>',
			scope: {
				snPayment: '='
			},
			replace: true,
			transclude: true,
			link(scope) {
				if (scope.snPayment.paid) {
					scope.paymentStatus = 'Paid';
				} else {
					scope.paymentStatus = scope.snPayment.late ? 'Late' : 'Unpaid';
				}
			}
		};
	}
]);



// WEBPACK FOOTER //
// ./web/js/components/pageInvoice/tdPaid.js